<div class="container-content position-relative">
  <div
    class="d-flex justify-content-end align-items-end gap-2 mb-3"
  >
    <div>
      <label for="university-search" class="form-label">
        {{ 'label.search' | translate }}
      </label>
      <input
        id="university-search"
        [(ngModel)]="search"
        class="form-control"
        type="search"
      />
    </div>
    <button
      [routerLink]="['create']"
      class="btn btn-primary rounded-circle d-flex align-items-center justify-content-center"
      type="button"
      [attr.aria-label]="
        'label.university.create' | translate
      "
    >
      <i class="bi bi-plus-lg"></i>
    </button>
  </div>

  <table class="table table-hover table-striped">
    <thead>
      <tr>
        <th scope="col">{{ 'label.name' | translate }}</th>
      </tr>
    </thead>
    <tbody>
      <tr
        *ngFor="let university of items"
        [routerLink]="[university.translationKey]"
        class="cursor-pointer"
      >
        <td>{{ name(university) }}</td>
      </tr>
    </tbody>
  </table>

  <app-loading-indicator-full
    *ngIf="loading"
  ></app-loading-indicator-full>
</div>
